export default __webpack_public_path__ + "static/media/file.4e55f299.svg";